import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core'
import { FormFieldComponent } from '../form-field/form-field.component'

@Component({
  selector: 'app-form-radio',
  templateUrl: './form-radio.component.html',
  styleUrls: ['../form-field-common.scss', './form-radio.component.scss'],
  host: { class: 'custom-control custom-radio' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormRadioComponent extends FormFieldComponent {
  @Input() groupId: string

  radioValue: any
  @Input() set value(v: any) {
    this.radioValue = v
  }

  @HostBinding('class.active') get isActive() {
    return this.ngControl?.value === this.radioValue
  }
}
